import { LoaderFunctionArgs } from 'react-router-dom';
import { QueryClient } from '@tanstack/react-query';
import { SamdAppRepository } from '@samd/api/app_repository';
import { AppRepository } from 'src/api/app_repository';
import { getPlatform } from 'src/config/environment';
import { DistributionPlatform } from 'src/types/env';

export function createLayoutLoader(
  queryClient: QueryClient,
  appRepository: AppRepository,
) {
  return async (_args: LoaderFunctionArgs) => {
    if (getPlatform() === DistributionPlatform.Samd) {
      return layoutLoaderSamd(
        queryClient,
        appRepository as SamdAppRepository,
      )();
    }
    return layoutLoaderLdt();
  };
}

/** SaMD: fetch build versions for the layout. */
function layoutLoaderSamd(
  queryClient: QueryClient,
  appRepository: SamdAppRepository,
) {
  return async () => {
    const queryKey = ['buildVersions'];
    await queryClient.ensureQueryData({
      queryKey,
      queryFn: async () => appRepository.fetchBuildVersions(),
    });
    return { queryKey };
  };
}

/** LDT: org is resolved in organization middleware before loaders run; layout loader has nothing to do. */
function layoutLoaderLdt() {
  return async () => ({});
}
